<!-- <ng-container [ngSwitch]="readonly && readonlyAsText">
  <div class="checkbox-wrapper" [class.readonly]="readonly" *ngSwitchDefault>
    <label class="checkbox-container gap-[10px]">
      <input
        type="checkbox"
        [checked]="isChecked"
        (change)="select($event)"
        name="checkbox-{{ for }}"
      />
      <span class="checkmark"></span>
      <span class="text-nowrap text-dirtyPurple" *ngIf="label">
        {{ label | translate }}
      </span>
      <ng-content></ng-content>
    </label>
  </div>

  <ng-container *ngSwitchCase="true">
    {{ isChecked | translateEnum: "Bool" }}
  </ng-container>
</ng-container> -->

<ng-container [ngSwitch]="readonly && readonlyAsText">
  <ng-container [ngSwitch]="formGroup ? true : false" *ngSwitchDefault>

    <ng-container *ngSwitchCase="true" [formGroup]="formGroup">
      <mat-checkbox
        [checked]="isChecked"
        [formControlName]="for"
        [disabled]="disabled"
        (change)="change.emit($event)"
      >
        <span class="text-nowrap text-dirtyPurple" *ngIf="label">
          {{ label | translate }}
        </span>
        <ng-content></ng-content>
      </mat-checkbox>
    </ng-container>

    <ng-container *ngSwitchCase="false">
      <mat-checkbox [checked]="isChecked" [disabled]="disabled">
        <span class="text-nowrap text-dirtyPurple" *ngIf="label">
          {{ label | translate }}
        </span>
        <ng-content></ng-content>
      </mat-checkbox>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="true">
    {{ isChecked | translateEnum: "Bool" }}
  </ng-container>
</ng-container>
